import * as types from '../../constants/wallet/settlementConstants';

export const walletSettlementListRequest = ({
  transactionStatus,
  settlementType,
  from,
  to,
  settlementIds,
  callback,
  error,
}) => ({
  type: types.WALLET_SETTLEMENT_LIST_REQUEST,
  transactionStatus,
  settlementType,
  from,
  to,
  settlementIds,
  callback,
  error,
});

export const settlementListApprovalRequest = ({
  issuer,
  dryRun,
  settlementIds,
  callback,
  error,
}) => ({
  type: types.SETTLEMENT_LIST_APPROVAL_REQUEST,
  issuer,
  dryRun,
  settlementIds,
  callback,
  error,
});
